import { gql } from '@apollo/client';

export const getPersonDetailsForm = gql(`
    query getPersonalInfoEnums {
      PersonType: __type(name: "PersonType") {
        name
        enumValues {
          name
          __typename
        }
        __typename
      }
      PhoneType: __type(name: "PhoneType") {
        name
        enumValues {
          name
        }
      }
      Gender: __type(name: "Gender") {
        name
        enumValues {
          name
        }
      }
      MaritalStatus: __type(name: "MaritalStatus") {
        name
        enumValues {
          name
        }
      }
      PersonRelation: __type(name: "PersonRelation") {
        name
        enumValues {
          name
        }
      }
      core {
        getTitles {
          id
          code
          title
        }
        getCountries {
          id
          code
          title
        }
        getNationalities {
          id
          code
          title
        }
        getOccupationClass{
          id
          code
          title
        }
      }
      salesforce {
        getAllPersons {
          id
          code
          fullName
        }
      }
    }
  `);

export const getAdditionalInformationEnums = gql`
  query getAdditionalInformationEnums {
    Gender: __type(name: "Gender") {
      name
      enumValues {
        name
      }
    }
    MaterialStatus: __type(name: "MaterialStatus") {
      name
      enumValues {
        name
      }
    }
    core {
      getCountries {
        id
        code
        title
      }
      getNationalities {
        id
        code
        title
      }
    }
  }
`;

export const getPersonAddressDetails = gql`
  query getPersonAddressDetails($personAddressId: String!) {
    salesforce {
      getPersonAddressDetails(personAddressId: $personAddressId) {
        addressType
        createdBy
        createdOn
        id
        isPrimary
        modifiedBy
        modifiedOn
        personId
        status
        address {
          addressDetails
          addressDetailsArabic
          building
          city
          country
          street
          zone
        }
      }
    }
  }
`;

export const getPersonAddressLovs = gql`
  query getPersonAddressLovs {
    PersonAddressType: __type(name: "PersonAddressType") {
      name
      enumValues {
        name
      }
    }
    core {
      getCountries {
        id
        code
        title
      }
      getZones {
        id
        code
        title
      }
    }
  }
`;

export const getActivePersonsList = gql`
  query {
    salesforce {
      getActivePersons {
        id
        fullName
        email
        phoneDetails {
          phoneNumber
          phoneType
        }
        isTaxable
      }
    }
  }
`;

export const getActivePersonsWithoutBusinessPartnersList = gql`
  query {
    salesforce {
      getActivePersonsWithoutBusinessPartners {
        id
        fullName
        status
      }
    }
  }
`;

export const getBusinessPartnerTypeEnumList = gql`
  query {
    BusinessPartnerType: __type(name: "BusinessPartnerType") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const getCountriesList = gql`
  query {
    core {
      getCountries {
        id
        title
        code
      }
    }
  }
`;

export const getCurrenciesList = gql`
  query {
    core {
      getCurrencies {
        id
        title
        code
        symbol
      }
    }
  }
`;

export const getPersonDetailsList = gql`
  query getPersonDetails($id: String!) {
    salesforce {
      getPersonDetails(id: $id) {
        email
        phoneDetails {
          phoneNumber
          phoneType
        }
      }
    }
  }
`;

export const getRelatedCompaniesList = gql`
  query {
    salesforce {
      getRelatedCompanies {
        id
        title
        code
      }
    }
  }
`;

export const getTitlesList = gql`
  query {
    core {
      getTitles {
        id
        title
        code
      }
    }
  }
`;

export const getZonesList = gql`
  query {
    core {
      getZones {
        id
        title
        code
      }
    }
  }
`;

export const getVignetteRangeDetails = gql`
  query getVignetteRangeDetails($id: String!) {
    salesforce {
      getBusinessPartnerVignetteRangeById(id: $id) {
        businessPartnerID
        createdBy
        createdOn
        id
        modifiedBy
        modifiedOn
        rangeFrom
        rangeTo
        status
        vignetteCode
        vignetteYear
        businessPartner {
          auxiliaryAccount
          code
          createdBy
          createdOn
          fullName
          hasAccessToAllInsured
          id
          isCompany
          isLocal
          isRegistered
          maxCreditLimitAllowed
          maxCreditLimitAllowedCurrency
          modifiedBy
          modifiedOn
          personId
          registerationExpiryDate
          registerationNumber
          relatedCompany
          status
          taxAuxiliaryAccount
          totalCreditLimitReached
          type
        }
      }
    }
  }
`;

export const getVignetteRangeStatusLOV = gql`
  query getVignetteRangeStatusLOV {
    VignetteStatus: __type(name: "VignetteStatus") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const getBusinessUserLovs = gql`
  query getBusinessUserLovs {
    UserStatus: __type(name: "UserStatus") {
      name
      enumValues {
        name
      }
    }
    UserType: __type(name: "UserType") {
      name
      enumValues {
        name
      }
    }
    PersonAddressType: __type(name: "PersonAddressType") {
      name
      enumValues {
        name
      }
    }
    core {
      getUserAccesses {
        code
        title
        id
      }
      getRoles
      getTitles {
        code
        title
        id
      }
      getCountries {
        code
        title
        id
      }
      getZones {
        code
        title
        id
      }
    }
    salesforce {
      searchPersons(
        pagination: { pageNumber: 1, pageSize: 1000 }
        selectedTypes: ["INDIVIDUAL"]
        selectedStatuses: ["ACTIVE"]
      ) {
        items {
          id
          fullName
          userId
        }
      }
    }
  }
`;

export const getPersonDetailsById = gql`
  query getPersonDetailsById($personId: String!) {
    salesforce {
      getPersonById(personId: $personId) {
        email
        firstName
        lastName
        middleName
        title
        phoneDetails {
          phoneNumber
          phoneType
        }
      }
    }
  }
`;

export const checkBusinessUserByPerson = gql`
  query checkBusinessUserByPerson($selectedPersonID: String!) {
    SalesforceManagement {
      queries {
        checkBusinessUserByPerson(selectedPersonID: $selectedPersonID) {
          salesforceManagement_BusinessUser_Id
          salesforceManagement_BusinessUser_PersonID {
            id
            views {
              SalesforceManagement_all {
                properties {
                  FullName
                  PersonCode
                }
              }
            }
          }
          salesforceManagement_BusinessUser_Status
        }
      }
    }
  }
`;

export const getPersonEmailDetailsInfo = gql`
  query getPersonEmailDetailsInfo($id: String!) {
    SalesforceManagement {
      entities {
        person(id: $id) {
          views {
            SalesforceManagement_all {
              properties {
                Email
              }
            }
          }
        }
      }
    }
  }
`;

export const getProviderLOVs = gql`
  query {
    salesforce {
      getProviderTypes {
        id
        title
        code
      }
      getActivePersonsNonProvider {
        id
        fullName
        email
        phoneDetails {
          phoneNumber
          phoneType
        }
        isTaxable
      }
    }
    providerStatusList: __type(name: "ProviderStatusList") {
      name
      enumValues {
        name
      }
    }
    personAddressType: __type(name: "PersonAddressType") {
      name
      enumValues {
        name
      }
    }
    phoneType: __type(name: "PhoneType") {
      name
      enumValues {
        name
      }
    }
  }
`;
export const getAccountingTransferLovs = gql`
  query getAccountingTransferLovs {
    accounting {
      getTransferTypeLookup {
        id
        code
        title
        createdOn
        modifiedOn
      }
    }
  }
`;
export const getAmendmentSubtypesQuery = gql`
  query getAmendmentSubTypes {
    production {
      getAmendmentSubTypes {
        id
        code
        title
        createdOn
        modifiedOn
      }
    }
  }
`;

export const getSystemReferenceDateQuery = gql`
  query getSystemReferenceDate {
    core {
      getSystemReferenceDate
    }
  }
`;

export const getClosedMonthQuery = gql`
  query getClosedMonth($type: String) {
    core {
      GetClosedMonth(type: $type) {
        closingMonth
        closingPeriodFrom
        closingPeriodTo
        closingReferenceNumber
        closingTypeID
        closingYear
        createdBy
        createdOn
        id
        modifiedBy
        modifiedOn
      }
    }
  }
`;

export const getLineRefDate = gql`
  query getLineRefDate($lineCode: String!) {
    core {
      getLineRefDate(lineCode: $lineCode) {
        refDate
      }
    }
  }
`;

export function getPolicyPersonEnums() {
  return gql`
    query getPolicyPersonEnums {
      PolicyPersonTypeList: __type(name: "PolicyPersonTypeList") {
        name
        enumValues {
          name
          __typename
        }
        __typename
      }
      PhoneType: __type(name: "PhoneType") {
        name
        enumValues {
          name
        }
      }
      Gender: __type(name: "Gender") {
        name
        enumValues {
          name
        }
      }
      PersonAddress: __type(name: "PersonAddress") {
        name
        enumValues {
          name
        }
      }
      PersonAddressType: __type(name: "PersonAddressType") {
        name
        enumValues {
          name
        }
      }
      PersonType: __type(name: "PersonType") {
        name
        enumValues {
          name
        }
      }
      core {
        getTitles {
          id
          title
        }
        getNationalities {
          id
          title
        }
        getOccupationClass {
          id
          title
        }
        getCountries {
          id
          title
        }
        getZones {
          id
          title
        }
      }
    }
  `;
}
